export const babyTrustData = [
  {
    image:
      'https://images.myloapp.in/NestJsUploads/1700033463515-2x3_Aanayra.webp',
    id: 1,
  },
  {
    image:
      'https://images.myloapp.in/NestJsUploads/1700033463518-2x3_Adyanvi.webp',
    id: 2,
  },
  {
    image:
      'https://images.myloapp.in/NestJsUploads/1700033463520-2x3_Bhagyata.webp',
    id: 3,
  },
  // {
  //     image: "https://images.myloapp.in/NestJsUploads/1700033463521-2x3_Kabeer.webp",
  //     id: 4,
  // },
  {
    image:
      'https://images.myloapp.in/NestJsUploads/1700033463522-2x3_Kavish.webp',
    id: 4,
  },
  {
    image:
      'https://images.myloapp.in/NestJsUploads/1700033518041-2x3_Kohav.webp',
    id: 5,
  },
  {
    image:
      'https://images.myloapp.in/NestJsUploads/1700033518042-2x3_Yuvanya.webp',
    id: 6,
  },
];

export const expertCarouselData = [
  {
    image:
      'https://images.myloapp.in/NestJsUploads/1700216770186-MicrosoftTeams-image-(22).webp',
  },
  {
    image:
      'https://images.myloapp.in/NestJsUploads/1700216770183-MicrosoftTeams-image-(24).webp',
  },
  {
    image:
      'https://images.myloapp.in/NestJsUploads/1700216770186-MicrosoftTeams-image-(23).webp',
  },
];

export const motherReviewsData = [
  {
    content: {
      url: 'https://www.youtube.com/watch?v=oLiMfVn72jE',
    },
    thumbnailImage:
      'https://images.myloapp.in/NestJsUploads/1725521744803-1.webp',
  },
  {
    content: {
      url: 'https://www.youtube.com/watch?v=eFSx0SjCWko',
    },
    thumbnailImage:
      'https://images.myloapp.in/NestJsUploads/1725521744806-2.webp',
  },

  {
    content: {
      url: 'https://www.youtube.com/watch?v=jB384QUASy0',
    },
    thumbnailImage:
      'https://images.myloapp.in/NestJsUploads/1725521744806-3.webp',
  },
  {
    content: {
      url: 'https://www.youtube.com/watch?v=eWDODsSaUcU',
    },
    thumbnailImage:
      'https://images.myloapp.in/NestJsUploads/1725521744807-4.webp',
  },
];
export const doctorReviewsData = [
  {
    content: {
      url: 'https://youtube.com/shorts/2VBRuY-Is1g',
    },
    thumbnailImage:
      'https://images.myloapp.in/NestJsUploads/1717593700555-expertVideo3.webp',
  },
  {
    content: {
      url: 'https://youtu.be/-AfsKv59YVw',
    },
    thumbnailImage:
      'https://images.myloapp.in/NestJsUploads/1717593700552-expertVideo1.webp',
  },
  {
    content: {
      url: 'https://youtube.com/shorts/Z8DwCnNYEj0',
    },
    thumbnailImage:
      'https://images.myloapp.in/NestJsUploads/1717593700556-expertVideo4.webp',
  },

  {
    content: {
      url: 'https://youtu.be/fJeYxLBFiKU',
    },
    thumbnailImage:
      'https://images.myloapp.in/NestJsUploads/1717593700554-expertVideo2.webp',
  },
];
export const faqsData = [
  {
    title: 'When will I see the results after taking Ovaluna? ',
    text: 'Boosting fertility is a gradual process and results vary individually. Our experts recommend that you consume Ovaluna twice daily (1 after breakfast and 1 after dinner) for at least 6 months to see significant improvements in your fertility. ',
  },
  // {
  //     title: "Can women with PCOS/PCOD take Ovaluna? ",
  //     text: "Yes, women clinically diagnosed with PCOS, PCOD or irregular periods can safely consume Ovaluna. These fertility capsules can help maintain the menstrual cycle, regulate hormonal balance, and boost ovulation.",
  // },
  {
    title: 'Will it help in removing tubal blockage? ',
    text: 'Ovaluna can be helpful in cases of partial tubal blockage. In case of complete tubal blockage, please consult with your doctor. ',
  },
  {
    title: 'Can Ovaluna be taken with other fertility treatments? ',
    text: 'Consult with your doctor about any supplements or fertility treatments you are taking to ensure compatibility and avoid potential interactions. ',
  },
  {
    title:
      'On what day of my menstrual cycle should I start my Ovaluna course? ',
    text: 'You can start taking Ovaluna as soon as it is delivered to you irrespective of your cycle start date.',
  },
  {
    title:
      'What are the key ingredients in Ovaluna, and how do they boost fertility?',
    text: '',
    carouselImages: [
      'https://images.myloapp.in/NestJsUploads/1725621591753-1_Shatavari.webp',
      'https://images.myloapp.in/NestJsUploads/1725621610099-2_L-Methyl-folate.webp',
      'https://images.myloapp.in/NestJsUploads/1725621625771-3_CoQ10.webp',
      'https://images.myloapp.in/NestJsUploads/1725621638655-4_Zinc.webp',
      'https://images.myloapp.in/NestJsUploads/1725621651699-5_Vitamin-D2-Veg.webp',
      'https://images.myloapp.in/NestJsUploads/1725621668663-6_Vitamin-B12.webp',
    ],
  },
  {
    title: 'Why should I track my ovulation? ',
    text: 'Tracking your ovulation while trying to conceive is critical because the egg can only be fertilized within 12 to 24 hours, also known as the fertile window, after it is released. Knowing this fertile window allows you and your partner to time intercourse for maximizing your chances of getting pregnant. Use the below tool to know your estimated ovulation date or use Mylo Ovulation Test-Kit to confirm ovulation at home.',
    showTool: true,
  },
];

export const lactoFaqsData = [
  {
    title: 'How quickly will I see results after using Lactomama? ',
    text: 'Many moms notice a difference in milk supply within 7 days of regular use. ',
  },
  {
    title: 'Is Lactomama safe for me and my baby? ',
    text: 'Yes, Lactomama is made with safe, natural ingredients and is designed specifically for breastfeeding moms. ',
  },
  {
    title: 'How do I use Lactomama? ',
    text: 'Lactomama is easy to use. Just mix two scoops into a glass of milk, water or smoothie daily. ',
  },
  {
    title: 'Can I take Lactomama with other medications or supplements? ',
    text: 'Lactomama is safe with most supplements, but it’s always a good idea to check with your doctor if you’re on any specific medications.',
  },
  {
    title: 'Does Lactomama have any side effects? ',
    text: 'Lactomama is made from natural ingredients and usually does not cause any side effects.',
  },
  {
    title: 'Can Mylo Lactomama be consumed while recovering from a C-section? ',
    text: 'Absolutely! Its ingredients like Moringa and Panchatrina Mool aid postpartum recovery and enhance lactation.',
  },
  {
    title:
      'What are the key ingredients in Mylo Lactomama, and how do they support lactation? ',
    text: 'It contains Shatavari, Sowa, Safed Jeera, Moringa, Panchatrina Mool, Vidaaree Kanda, and Palak. These natural herbs boost breast milk production, regulate hormones, aid postpartum recovery, and improve overall health.',
  },
];
export const detergentFaqsData = [
  {
    title:
      "Can baby laundry detergents cause rashes on my baby's skin? How does Mylo prevent this?",
    text: "Yes, regular detergents can cause rashes due to harsh chemicals. Mylo prevents this with a hypoallergenic, dermatologically-tested formula free from irritants, making it safe and gentle for delicate baby skin. It's ideal for babies prone to sensitivity or skin conditions.",
  },
  {
    title:
      'Does Mylo baby detergent kill germs and bacteria on clothes (antibacterial)?',
    text: 'Yes, Mylo detergent contains natural antibacterial ingredients like neem and basil, which help eliminate germs, mold, and bacteria from baby clothes. This ensures clothes are hygienically clean without the use of harsh chemical sanitizers.',
  },
  {
    title: 'Is Mylo Baby Detergent free from harsh chemicals and allergens?',
    text: "Yes, Mylo is completely free from harsh chemicals like phosphates, parabens, sulfates, and artificial dyes. It's also allergen-free and Made Safe Certified, making it ideal for babies with sensitive skin or allergies.",
  },
  {
    title:
      'Can Mylo detergent remove tough stains (food, poop, milk spits) effectively?',
    text: "Yes, Mylo's enzyme-based formula is effective at removing tough stains such as milk, food, and poop. It cleans deeply while being gentle on baby clothes, so there's no need for scrubbing or pre-soaking.",
  },
  {
    title:
      "Will Mylo detergent keep my baby's clothes soft and maintain the fabric quality?",
    text: 'Yes, Mylo keeps baby clothes soft and maintains fabric quality. It avoids harsh chemicals that cause stiffness and uses a balanced pH to retain fabric softness and color, ensuring baby clothes stay cozy and snuggly.',
  },
  {
    title: 'Is Mylo Baby Laundry Detergent eco-friendly?',
    text: "Yes, Mylo is eco-friendly. It's made from biodegradable, plant-based ingredients and is phosphate-free, ensuring it breaks down naturally and doesn't harm the environment.",
  },
  {
    title:
      'Does Mylo baby detergent have any fragrance? Is it safe for babies?',
    text: "Mylo has a mild, natural fragrance that's safe for babies. It doesn't use artificial perfumes or allergens, so clothes smell fresh without irritating sensitive skin or triggering allergies.",
  },
  {
    title:
      'How do I measure and use Mylo detergent? Does it come with a convenient dispenser?',
    text: 'Yes, Mylo is easy to use. It comes with a measuring cap for accurate dosage and dissolves easily in water, ensuring a mess-free laundry experience for both hand wash and machine wash.',
  },
  {
    title:
      'Do I really need a special baby detergent like Mylo for infant clothes, instead of regular detergent?',
    text: "Yes, it's important to use baby-specific detergents like Mylo. Regular detergents can contain irritants harmful to infants. Mylo is specially formulated for babies, ensuring safe, effective cleaning without risks of skin irritation.",
  },
  {
    title:
      'Is Mylo detergent suitable for all washing machines and hand washing?',
    text: "Yes, Mylo works in both front-load and top-load machines, and for hand washing too. It's low-sudsing, dissolves easily, and won't damage machines, making it versatile and easy for all laundry methods.",
  },
  {
    title:
      'Does Mylo detergent rinse out completely without leaving any residue?',
    text: 'Yes, Mylo rinses out completely without leaving residue. Its formula uses water-soluble, plant-based ingredients that wash away fully, reducing risks of skin irritation and keeping clothes soft and safe for babies.',
  },
];

export const diaperPdpIds = [2378];

export const diaperComboPdpIds = [3525, 3530, 2890, 2891, 2892, 2893];

export const lactoMamaPdp = [3878, 3928, 3929];

export const wrapperFeatureData = [
  {
    image: 'https://images.myloapp.in/NestJsUploads/1729067924171-age-(1).svg',
    text: 'For 0-6 Months Babies',
  },
  {
    image:
      'https://images.myloapp.in/NestJsUploads/1729067924171-sleep-(1).svg',
    text: 'Promotes Better Sleep',
  },
  {
    image:
      'https://images.myloapp.in/NestJsUploads/1729067924169-all-season.svg',
    text: 'All season protection',
  },
];
export const lactoFeatureData = [
  // {
  //   image:
  //     'https://images.myloapp.in/mydo_upload/mydo_upload_1761227848_1388721550.png',
  //   text: 'Ideal for Full Feeding Journey',
  // },
  {
    image:
      'https://images.myloapp.in/NestJsUploads/1762779539507-100-Natural-icon.webp',
    text: '100% Natural Ingredients',
  },
  {
    image:
      'https://images.myloapp.in/NestJsUploads/1731064995045-clinically-tested.webp',
    text: 'Clinically Tested \n & Certified',
  },
  {
    image: 'https://images.myloapp.in/NestJsUploads/1731064995023-7-days.webp',
    text: 'Visible results \n in 1 week',
  },
];
export const diaperFeatureData = [
  {
    image: 'https://images.myloapp.in/NestJsUploads/1743167091850-d2.webp',
    text: 'Upto 12hr Leakproof Protection',
  },
  {
    image: 'https://images.myloapp.in/NestJsUploads/1743167106811-d3.webp',
    text: 'No Rashes with Aloe vera lotion',
  },
  {
    image: 'https://images.myloapp.in/NestJsUploads/1743167044390-d1.webp',
    text: '360° Absorption',
  },
];
export const stretchMarksFeatureData = [
  {
    image:
      'https://images.myloapp.in/NestJsUploads/1731064995044-100-natural.webp',
    text: '100% Natural Ingredients',
  },
  {
    image:
      'https://images.myloapp.in/NestJsUploads/1731064995045-clinically-tested.webp',
    text: 'Clinically Tested & Certified',
  },
  {
    image:
      'https://images.myloapp.in/NestJsUploads/1745382015834-28-days-result.webp',
    text: 'Visible results in 28 days',
  },
];
export const detergentFeatureData = [
  {
    image: 'https://images.myloapp.in/NestJsUploads/1746536763290-0plus.webp',
    text: 'Suitable for all babies',
  },
  {
    image:
      'https://images.myloapp.in/NestJsUploads/1746522769598-sensitive-skin.svg',
    text: 'Safe for Sensitive Skin ',
  },
  {
    image:
      'https://images.myloapp.in/NestJsUploads/1746522790125-no-chemicals.svg',
    text: 'No harmful chemicals',
  },
];
export const detergentCleanserComboFeatureData = [
  {
    image:
      'https://images.myloapp.in/NestJsUploads/1748496750452-Anti-Bacterial.webp',
    text: 'Anti-bacterial',
  },
  {
    image:
      'https://images.myloapp.in/NestJsUploads/1748496919558-Derma-tested.webp',
    text: 'Dermatologically Tested',
  },
  {
    image:
      'https://images.myloapp.in/NestJsUploads/1748496949913-baby-safe.webp',
    text: '100% Baby Safe',
  },
];
